function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import tasks from '@/js/tasks';
import { TYPE_CHANGE_METADA, DEFAULT_TPL_FIELDS } from '@/js/constants';
import ProfilingColumns from '@/components/profiling/ProfilingColumns';
import ProfilingExecutionDetails from '@/components/profiling/ProfilingExecutionDetails';
import ProfilingRules from '@/components/profiling/ProfilingRules';
import ProfilingTableResult from '@/components/profiling/ProfilingTableResult';
import ProfilingLogs from '@/components/profiling/ProfilingLogs';
import ModalConfirm from '@/components/ModalConfirm';
export default {
  name: 'FormMetadataProfiling',
  components: {
    ProfilingColumns: ProfilingColumns,
    ProfilingRules: ProfilingRules,
    ProfilingExecutionDetails: ProfilingExecutionDetails,
    ProfilingTableResult: ProfilingTableResult,
    ProfilingLogs: ProfilingLogs,
    ModalConfirm: ModalConfirm
  },
  props: {
    tplToWork: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    isChangeRequest: {
      type: String,
      required: false,
      default: TYPE_CHANGE_METADA.UPDATE
    },
    item: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    queryPreviousProfiling: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data: function data() {
    return {
      userInfo: {},
      DEFAULT_TPL_FILEDS_AREA_ENUM: [],
      DEFAULT_TPL_FILEDS_ZONE_ENUM: [],
      MODAL_CONFIRM_EDIT: 'MODAL_CONFIRM_EDIT',
      defaultFields: {},
      columnFields: [],
      isLoading: false,
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      selectBusinessDomain: [],
      selectbusinessSubdomain: [],
      domain_table: '',
      profilingRule: {},
      tableReference: {},
      document_id: '',
      existsCurrentProfiling: false,
      isEditableCurrentProfiling: true,
      record: Object,
      executionDetails: [],
      isSubmitting: false
    };
  },
  computed: {
    texts: function texts() {
      return {
        rules: this.traductor('tabs.rules'),
        columns: this.traductor('tabs.columns')
      };
    }
  },
  created: function created() {
    this.userInfo = tasks.getUserInfo();
    this.cEmail = this.userInfo.email;
    if (this.isChangeRequest === TYPE_CHANGE_METADA.UPDATE) {
      this.setEditVars();
    }
    // Separe defaultTemplate and Columnfields
    if (!this.tplToWork.objects || !this.tplToWork.objects.tags) {
      return undefined;
    }
    var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.objects.tags);
    this.relativeResourceName = this.tplToWork.item.relativeResourceName;
    this.domain_table = this.tplToWork.item.domain_table;
    this.tableReference = this.tplToWork.item.tableReference;
    this.document_id = this.record.document_id || '';
    this.defaultFields = separeValues.defaultFields;
    this.columnFields = this.parseColumns(separeValues.columnFields);
    this.profilingRule['owner'] = this.defaultFields[DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue;
    this.profilingRule['organization'] = this.defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name].stringValue;
    if (this.queryPreviousProfiling) {
      this.getDefaultProfilingRule();
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    setEditVars: function setEditVars() {
      this.columnFields = this.item.columns;
      var table_reference_item = this.item.tableReference;
      this.tableReference = {
        'projectId': table_reference_item.project,
        'datasetId': table_reference_item.bigquery_dataset,
        'tableId': table_reference_item.bigquery_table
      };
      this.domain_table = this.item.domainTable;
      this.profilingRule = this.item.profilingRule;
      this.document_id = this.item.document_id;
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onCancel: function onCancel(event) {
      if (event) {
        event.preventDefault();
      }
      this.$emit('cancel', null);
    },
    parseColumns: function parseColumns(records) {
      var columns = [];
      var _iterator = _createForOfIteratorHelper(records),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var record = _step.value;
          columns.push({
            name: record.column,
            businessDefinition: record.fields.business_definition.stringValue,
            validationTypes: [],
            isSelected: false,
            isPrimaryKey: false,
            isPriority: false,
            isPartition: false
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return columns;
    },
    getDefaultProfilingRule: function getDefaultProfilingRule() {
      var _this = this;
      var params = {
        tableReference: this.tplToWork.item.tableReference
      };
      this.isLoading = !this.isLoading;
      DataProfilingService.getProfilingHistory(params).then(function (response) {
        if (response.data && response.data.length) {
          _this.record = response.data[0];
          _this.profilingRule = _this.record.profilingRule;
          _this.columnFields = _this.record.columns;
          _this.executionDetails = _this.record.executionDetails || [];
          _this.existsCurrentProfiling = true;
          if (Object.keys(_this.record.resultsTable).length) {
            _this.record.resultsTable.document_id = _this.record.document_id;
          }
        }
        _this.isLoading = !_this.isLoading;
      });
    },
    operationProfilingRule: function operationProfilingRule() {
      var _this2 = this;
      var params = {
        columns: this.columnFields,
        tableReference: this.tableReference,
        domainTable: this.domain_table,
        profilingRule: this.validateFieldsProfilingRule(this.profilingRule),
        documentId: this.document_id
      };
      this.isSubmitting = true;
      var request = this.isChangeRequest === TYPE_CHANGE_METADA.UPDATE ? DataProfilingService.editProfilingRule(params) : DataProfilingService.createProfilingRule(params);
      request.then(function (response) {
        _this2.isSubmitting = false;
        if (response && !response.success) {
          _this2.dismissCountDown = _this2.dismissSecs;
          _this2.dangerMessage = response.message;
        } else {
          tasks.toast.success('Profiling params have been recorded successfully. Check it out in Data Quality > Profiling History');
          //this.$toast.success('Profiling params have been recorded successfully. Check it out in Data Quality > Profiling History')
          _this2.$emit('submit', response);
        }
      }).finally(function () {
        if (_this2.isChangeRequest === TYPE_CHANGE_METADA.UPDATE) _this2.closeModal(_this2.MODAL_CONFIRM_EDIT);
      });
    },
    validateFieldsProfilingRule: function validateFieldsProfilingRule(profilingRule) {
      // Valida que los campos no requeridos estén llenos antes de mandarse
      if (profilingRule && profilingRule['tableFilter'] === '') {
        delete profilingRule['tableFilter'];
      }
      return profilingRule;
    },
    closeModal: function closeModal(modalName) {
      this.$bvModal.hide(modalName);
    },
    onSubmit: function onSubmit(event) {
      //event.preventDefault()
      if (!this.$refs.form.validate()) return;
      if (!this.columnFields.filter(function (column) {
        return column.isSelected;
      }).length) {
        this.dismissCountDown = this.dismissSecs;
        this.dangerMessage = 'At least one row is required, check "Columns" tab';
        return;
      }
      if (this.isChangeRequest === TYPE_CHANGE_METADA.UPDATE) {
        this.$bvModal.show(this.MODAL_CONFIRM_EDIT);
      } else {
        this.operationProfilingRule();
      }
    }
  }
};